import { allModelsSelector } from 'common-src/utils/selectorUtils';

import { ExemptionStatus, ExemptionType } from './constants';

export const getPatientBillingExemptions = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientBillingExemption',
    (billingExemption) => billingExemption.patientId === patientId,
  );

export const getMfaExemptions = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientBillingExemption',
    (billingExemption) =>
      billingExemption.patientId === patientId &&
      billingExemption.exemptionType === ExemptionType.MFA.value,
  );

export const getActiveMfaExemptions = (state, patientId) =>
  getMfaExemptions(state, patientId).filter(
    (billingExemption) => billingExemption.status === ExemptionStatus.Active.value,
  );
